"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cutStringDot = cutStringDot;
exports.formatMoney = exports["default"] = void 0;

var phoneFormat = function phoneFormat() {
  var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var str = phoneNumber.replace(/\s/g, '');

  if (str.includes('-')) {
    return str;
  }

  var len = str.length;

  switch (true) {
    case len > 11:
      str = str.substr(0, 3) + ' ' + str.substr(3, 4) + ' ' + str.substr(7, 4);
      break;

    case len > 7:
      str = str.substr(0, 3) + ' ' + str.substr(3, 4) + ' ' + str.substr(7);
      break;

    case len > 3:
      str = str.substr(0, 3) + ' ' + str.substr(3);
      break;

    default:
  }

  return str;
};

var moneyFormat = function moneyFormat(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var dec_point = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  var thousands_sep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ',';
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
  var dec = typeof dec_point === 'undefined' ? '.' : dec_point;
  var s = '';

  var toFixedFix = function toFixedFix(n) {
    var k = Math.pow(10, n.toString().split('.')[1] ? n.toString().split('.')[1].length : 0);
    return '' + Math.ceil(n * k) / k;
  };

  s = (prec ? toFixedFix(n) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;

  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2');
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }

  return s.join(dec);
};

var formatAmount = function formatAmount(val) {
  var str = "".concat((val / 100).toFixed(2));
  var intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ',');
  var dot = str.substring(str.length, str.indexOf('.'));
  var ret = intSum + dot;
  return ret;
};

var formatMoney = function formatMoney(money) {
  var formatedMoney = String(money * 0.01);

  if (parseInt(formatedMoney, 0) === parseFloat(formatedMoney)) {
    return parseInt(formatedMoney, 0).toFixed(0);
  } else {
    return parseFloat(formatedMoney).toFixed(2);
  }
};

exports.formatMoney = formatMoney;

function trimAll() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result;
  result = str.replace(/(^\s+)|(\s+$)/g, '');
  result = result.replace(/\s/g, '');
  return result;
}

var cutString = function cutString(str, len) {
  var strlen = 0;
  var restr = '';

  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 128) {
      strlen += 2;
    } else {
      strlen++;
    }

    restr += str.charAt(i);

    if (strlen >= len) {
      return restr;
    }
  }

  return restr;
};

function cutStringDot(str, len) {
  if (str.length * 2 <= len) {
    return str;
  }

  var strlen = 0;
  var s = '';

  for (var i = 0; i < str.length; i++) {
    s = s + str.charAt(i);

    if (str.charCodeAt(i) > 128) {
      strlen = strlen + 2;

      if (strlen >= len) {
        return s.substring(0, s.length - 1) + '...';
      }
    } else {
      strlen = strlen + 1;

      if (strlen >= len) {
        return s.substring(0, s.length - 2) + '...';
      }
    }
  }

  return s;
}

var replaceAllHolder = function replaceAllHolder() {
  var originText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var replaceArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var tagName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'span';
  var index = 0;
  return originText.replace(/%s/g, function (i) {
    return "<".concat(tagName, ">").concat(replaceArr[index++] || '', "</").concat(tagName, ">");
  });
};

var subStringByCode = function subStringByCode(str, subLength) {
  try {
    if (str == '' || str == null) {
      return '';
    }

    var temp1 = str.replace(/[^\u0000-\u00FF]/g, '**');
    var temp2 = temp1.substring(0, subLength);
    var x_length = temp2.split('\*').length - 1;
    var hanzi_num = x_length / 2;
    subLength = subLength - hanzi_num;
    var res = str.substring(0, subLength);

    if (subLength < str.length) {
      var end = res + '…';
    } else {
      var end = res;
    }

    return end;
  } catch (error) {
    return str;
  }
};

var encryptPhoneNumber = function encryptPhoneNumber(phone) {
  var reg = /(\d{3})\d{4}(\d{4})/;
  return String(phone).replace(reg, '$1****$2');
};

var _default = {
  encryptPhoneNumber: encryptPhoneNumber,
  subStringByCode: subStringByCode,
  replaceAllHolder: replaceAllHolder,
  cutStringDot: cutStringDot,
  formatAmount: formatAmount,
  cutString: cutString,
  moneyFormat: moneyFormat,
  trimAll: trimAll,
  phoneFormat: phoneFormat,
  formatMoney: formatMoney
};
exports["default"] = _default;